var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.37 8.135c.184 0 .337.13.372.303l.008.077v8.732c0 .113-.05.218-.134.29l-.068.046-8.327 4.401a.377.377 0 01-.117.04l-.06.004a.38.38 0 01-.373-.303l-.008-.076v-8.74c0-.112.05-.217.134-.289l.069-.046 8.327-4.395a.361.361 0 01.116-.039l.061-.005zm-18.634.016l.071.029 8.327 4.401c.1.053.17.146.194.253l.009.083v8.732a.376.376 0 01-.339.377l-.074.002a.376.376 0 01-.073-.014l-.071-.029-8.327-4.395a.377.377 0 01-.194-.253l-.009-.083V8.515a.38.38 0 01.339-.377l.074-.001a.376.376 0 01.073.014zm.9 2.027v6.412l6.243 3.261v-6.405l-6.243-3.268zm16.737.003l-6.35 3.33V19.9l6.35-3.336v-6.383zm-8.266-8.175l.069.028 8.28 4.36a.38.38 0 01.16.158.382.382 0 01-.095.471l-.065.043-8.288 4.373a.385.385 0 01-.286.028l-.069-.028-8.272-4.366a.38.38 0 01-.064-.629L3.54 6.4l8.28-4.367a.386.386 0 01.286-.028zm-.121 1.842l-5.94 2.889 5.94 2.884 5.963-2.891-5.963-2.882z",
    fill: "#151A30",
    fillRule: "evenodd"
  })));
}

export default SvgBox;